// Fachada do domínio Leads — re-exporta os métodos das instâncias (ver core.ts).
import { leadService, leadFlowService } from './core';

// Utilidades puras de importação CSV (sem estado/DI) — re-exportadas p/ a UI.
export { mapImportRows, requiredHeaderFor, templateHeadersFor, SIMPLE_HEADERS } from '@modules/leads';

// Primitivas (LeadService — 1 operação de dados por método).
export const createExternalLead = leadService.createExternalLead;
export const importLead     = leadService.importLead;
export const createFunnel       = leadService.createFunnel;
export const getLeadDetail    = leadService.getLeadDetail;
export const updateLead       = leadService.updateLead;
export const patchLead        = leadService.patchLead;
export const deactivateLead   = leadService.deactivateLead;
export const searchLeads      = leadService.searchLeads;
export const listMobileMyLeads = leadService.listMobileMyLeads;
export const listLeadsGraph   = leadService.listLeadsGraph;
export const createLeadWithInitialCard = leadService.createLeadWithInitialCard;
export const passLeadToCloser = leadService.passLeadToCloser;
export const sendLeadToCloserPipeline = leadService.sendLeadToCloserPipeline;
export const handoffLeadToComercial = leadService.handoffLeadToComercial;

// Use-cases de aplicação (LeadFlowService — orquestração multi-domínio).
export const createLeadFlow    = leadFlowService.createLead;
export const importLeadsFlow   = leadFlowService.importLeads;
export const updateLeadFlow    = leadFlowService.updateLead;
export const deleteLeadFlow    = leadFlowService.deleteLead;
export const markLeadsLostFlow = leadFlowService.markLeadsLost;
export const moveCardStageFlow = leadFlowService.moveCardStage;
export const passToCloserFlow  = leadFlowService.passToCloser;

export type {
  LeadRow,
  LeadWithGraph,
  LeadCardGraph,
  LeadTagGraph,
  LeadMeetingGraph,
  LeadDetail,
  LeadDetailCard,
  LeadDetailTag,
  LeadSearchResult,
  MobileLeadItem,
  MobileLeadsPage,
  LeadTagInput,
  CreateLeadInput,
  LeadCreateContext,
  LeadUpdateInput,
  CardMover,
  ProfileLite,
  LeadGraphVisibility,
  ImportProfile,
  ImportDefaults,
  ImportLeadFields,
  ImportLeadRow,
  ImportRowError,
  MapImportResult,
  ImportCardAction,
  ImportLeadOutcome,
  ImportLeadsResult,
  ImportLeadsOptions,
  BulkLossCardInput,
  BulkLossLeadInput,
  BulkLossFailure,
  BulkLossSkipped,
  BulkLossProgress,
  BulkLossResult,
} from '@modules/leads';
